import React from "react";
import { OrderLiveningIcpSiteDetails } from "../OrderLiveningIcpSiteDetails";
import { OrderNewConnectionSiteDetails } from "../OrderNewConnectionSiteDetails";
import { Flex } from "../../../Flex";
import { OrderDetailsSiteDetails } from "../../../../types/OrderDetailsSiteDetails";
import { NewConnectionTypes } from "../../../../types/OrderJobTypes";
import { OrderDocument } from "../../../../types/OrderDocument";
import { OrderDisconnectionSiteDetails } from "../OrderDisconnectionSiteDetails";

interface Props {
  siteDetails: OrderDetailsSiteDetails;
  documents: OrderDocument[];
}

export const OrderSiteDetails: React.FC<Props> = ({
  siteDetails,
  documents,
}) => {
  const { jobType, address, typeDetailed } = siteDetails;

  const renderSiteDetails = () => {
    if (jobType === "livening icp") {
      const { liveningIcpSiteDetails } = siteDetails;
      return (
        <OrderLiveningIcpSiteDetails
          address={address}
          liveningIcpSiteDetails={liveningIcpSiteDetails}
          documents={documents}
        />
      );
    } else if (jobType === "new connection") {
      const { newConnectionSiteDetails } = siteDetails;
      return (
        <OrderNewConnectionSiteDetails
          address={address}
          newConnectionType={typeDetailed as NewConnectionTypes}
          newConnectionSiteDetails={newConnectionSiteDetails}
          documents={documents}
        />
      );
    } else if (jobType === "disconnection") {
      const { disconnectionSiteDetails } = siteDetails;
      return (
        <OrderDisconnectionSiteDetails
          address={address}
          disconnectionSiteDetails={disconnectionSiteDetails}
          documents={documents}
        />
      );
    }
    return undefined;
  };

  return <Flex flexDirection="column">{renderSiteDetails()}</Flex>;
};
